<template>
  <div>
    <h2 class="w-logo"><img src="@assets/images/wx.png" /></h2>
    <b class="s-name">授权登录</b>
    <p class="s-p">此页面为授权登录页面,请点击下方 授权登录按钮</p>
    <UPButton @click="btnClick" :scope="scope" class="s-login">
      授权登录
    </UPButton>
  </div>
</template>
<script>
import { YsfLogin } from "@api/user";
import dayjs from "dayjs";
import cookie from "@utils/store/cookie";
const BACK_URL = "login_back_url";

export default {
  name: "Login",
  data: function() {
    return {
      scope: "scope.mobile"
    };
  },
  mounted: function() {},
  methods: {
    btnClick(event, err, result) {
      if (result) {
        console.log("授权成功: code" + result.code);
        let that = this;
        YsfLogin({
          code: result.code
        })
          .then(res => {
            let data = res.data;
            let newTime = Math.round(new Date() / 1000);
            that.$store.commit(
              "LOGIN",
              data.token,
              dayjs(data.expires_time) - newTime
            );
            const backUrl = cookie.get(BACK_URL) || "/";
            cookie.remove(BACK_URL);
            that.$router.replace({ path: backUrl });
          })
          .catch(res => {
            that.$dialog.error(res.msg);
          });
      }
    }
  }
};
</script>
<style scoped>
.w-logo {
  display: block;
  margin: 0 auto;
  margin-top: 130px;
  width: 90px;
}
.w-logo img {
  width: 90px;
}
.s-name {
  display: block;
  text-align: center;
  margin-top: 30px;
  font-size: 19px;
  color: #000;
  font-weight: bolder;
}
.s-p {
  font-size: 13px;
  color: #666666;
  line-height: 20px;
  text-align: center;
  padding: 0 80px;
  padding-top: 17px;
}
.s-login {
  background-color: #fff;
  display: block;
  width: 182px;
  height: 40px;
  border-radius: 100px;
  border: 1px solid #32a658;
  text-align: center;
  line-height: 40px;
  font-size: 16px;
  color: #32a658;
  font-weight: bolder;
  margin: 0 auto;
  margin-top: 100px;
}
</style>
<style>
body {
  background-color: #fff !important;
}
</style>
